// Search radius persistence using cookies
const RADIUS_COOKIE_NAME = 'crowdtrades_search_radius';
const COOKIE_EXPIRY_DAYS = 30;
const DEFAULT_RADIUS = 25;

// Set a cookie
const setCookie = (name: string, value: string, days: number) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
};

// Get a cookie
const getCookie = (name: string): string | null => {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
};

// Save user's search radius preference
export const saveRadiusPreference = (radius: number): void => {
  // Ensure radius is within valid bounds
  const validRadius = Math.max(5, Math.min(100, radius));
  setCookie(RADIUS_COOKIE_NAME, validRadius.toString(), COOKIE_EXPIRY_DAYS);
  console.log(`💾 Saved search radius preference: ${validRadius} miles`);
  
  // Debug: verify cookie was set
  const verification = getCookie(RADIUS_COOKIE_NAME);
  console.log(`🔍 Cookie verification - saved: ${validRadius}, read back: ${verification}`);
};

// Load user's search radius preference
export const loadRadiusPreference = (): number => {
  console.log('🔍 Loading radius preference...');
  const savedRadius = getCookie(RADIUS_COOKIE_NAME);
  console.log(`🔍 Raw cookie value: "${savedRadius}"`);
  
  if (savedRadius) {
    try {
      const parsed = parseInt(savedRadius);
      console.log(`🔍 Parsed value: ${parsed}, isNaN: ${isNaN(parsed)}, valid range: ${parsed >= 5 && parsed <= 100}`);
      if (!isNaN(parsed) && parsed >= 5 && parsed <= 100) {
        console.log(`🔄 Loaded saved search radius: ${parsed} miles`);
        return parsed;
      }
    } catch (error) {
      console.warn('Failed to parse saved radius, using default:', error);
    }
  }
  
  console.log(`🔄 Using default search radius: ${DEFAULT_RADIUS} miles (no valid saved value)`);
  return DEFAULT_RADIUS;
};

// Clear radius preference (for testing)
export const clearRadiusPreference = (): void => {
  setCookie(RADIUS_COOKIE_NAME, '', -1);
  console.log('🗑️ Cleared radius preference');
};